import {AfterViewInit, Component, OnInit} from '@angular/core';
import {LanguageChoice} from '../refugee-questionnaire/refugee-questionnaire.component';
import {SeoService} from '../shared/services/seo.service';
import { CmsPageService } from '../shared/services/cms-pages.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, AfterViewInit {
    LanguageChoice = LanguageChoice;

    pageContent: {[key : string] : string} = {}

    constructor(
        private seo: SeoService,
        private cmsPages: CmsPageService
    ) {}

    ngOnInit(): void {
        this.cmsPages.getPageContentBySlug('homepage').subscribe(pageContent => {
            this.pageContent = pageContent
            setTimeout(() => {
                // @ts-expect-error jerome stuff
                initJeromeJs();

                // @ts-expect-error jerome stuff
                $('.js-mh').matchHeight();
            }, 0);
        })

        this.seo.updateTags(
            'Scholenwijzer Den Haag',
            'De Scholenwijzer geeft ouders en kinderen informatie over alle verschillende scholen in Den Haag en omstreken. Dat maakt het kiezen van een school een stuk makkelijker! En er is nog veel meer uit de Scholenwijzer te halen. Hoe weet u welke school het beste past bij u en uw kind? Waar moet u op letten? Hoe werkt het aanmelden? De Scholenwijzer geeft antwoord op al deze vragen en meer.',
        );
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            // @ts-expect-error jerome stuff
            initJeromeJs();

            // @ts-expect-error jerome stuff
            $('.js-mh').matchHeight();
        }, 0);
    }

    contentLoaded():boolean {
        return Object.keys(this.pageContent).length > 0
    }
}
